import React from 'react'
import { ScreeningQuestion } from 'types/campaign'

const DEFAULT_BINARY_LABELS = ['Yes', 'No'] as const

interface ScreeningQuestionBinaryProps {
    question: ScreeningQuestion
    index: number
    value: string | number // 1 = Yes (first option), 0 = No (second option)
    onChange: (value: number) => void
    highlightError?: boolean
}

const ScreeningQuestionBinary: React.FC<ScreeningQuestionBinaryProps> = ({
    question,
    index,
    value,
    onChange,
    highlightError = false,
}) => {
    const opts = question.options?.filter(Boolean) ?? []
    const choices =
        opts.length >= 2 ? [opts[0], opts[1]] : [...DEFAULT_BINARY_LABELS]

    const groupName = `screening-binary-${question.id}`
    const selectedLabel =
        value === 1 ? choices[0] : value === 0 ? choices[1] : ''

    return (
        <div className="screening-question">
            <p className="screening-question__title" id={`${groupName}-label`}>
                {index + 1}. {question.question}
            </p>
            <div
                className="screening-question__binary-group"
                role="radiogroup"
                aria-labelledby={`${groupName}-label`}
            >
                {choices.map((choice, choiceIndex) => {
                    const selected = selectedLabel === choice
                    const numericValue = choiceIndex === 0 ? 1 : 0
                    return (
                        <button
                            key={choice}
                            type="button"
                            className={`screening-question__binary-btn${
                                selected ? ' screening-question__binary-btn--selected' : ''
                            }`}
                            onClick={() => onChange(numericValue)}
                        >
                            {choice}
                        </button>
                    )
                })}
            </div>
            {highlightError && (
                <div className="text-danger fs-14 mt-1">Please select a valid option</div>
            )}
        </div>
    )
}

export default ScreeningQuestionBinary
